import { render, staticRenderFns } from "./transetion-back-date.vue?vue&type=template&id=c35ac4c8&"
import script from "./transetion-back-date.vue?vue&type=script&lang=js&"
export * from "./transetion-back-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports